/**
 * Tiny className combiner — joins truthy values with a space.
 * Keeps conditional Tailwind classes readable without pulling in a dependency.
 *
 * @example cn('p-2', isActive && 'bg-brand-500', error ? 'text-red-600' : null)
 */
export function cn(...values) {
  return values.filter(Boolean).join(' ');
}
